<div class="filters-panel" [ngClass]="{'withBackground': background, 'withPadding': padding}">
  <div class="filters-panel__header">
    <h3>{{ 'Filters' | translate }}</h3>
    @if (showFilterIcon) {
      <button
        pButton type="button"
        class="p-button-text p-button-sm toggle-button"
        (click)="toggleFilters()"
      >
        <img src="/assets/icons/main/light/filter-lead-icon.svg" alt="Toggle filters"/>
      </button>
    }
  </div>

  @if (isLoading) {
    <app-loading [loading]="isLoading">

    </app-loading>
  } @else {
    <div class="filters-panel_content flex-column align-content-around flex">
      <div>
        <msf-form-builder
          [fields]="fields"
          [(model)]="model"
          [metaData]="metaData"
          (modelChange)="modelChange.emit(model)"
        ></msf-form-builder>
      </div>

      <div class="filter-actions mt-6 flex flex-column gap-2">
        <p-button
          [label]="'Apply' | translate"
          (click)="applyFilters()"
          [loading]="isLoading"
          styleClass="p-button-dark w-full">
        </p-button>
        <app-clear-button
          (clear)="clearFilters()"
          styleClass="w-full"
        >
        </app-clear-button>
      </div>
      @if (save) {
        <div class="filter-actions mt-2">
          <p-button
            [label]="'Save' | translate"
            (click)="saveFilter()"
            label="Secondary" severity="secondary"
            [outlined]="true" styleClass="w-full">
          </p-button>
        </div>
      }
      @if (import) {
        <div class="filter-actions mt-2">
          <app-secondary-button
            [style.width]="'100%'"
            (action)="onImport.emit()"
            [icon]="'pi pi-upload'"
            [title]="'Import' | translate"
          ></app-secondary-button>
        </div>
      }
      @if (export) {
        <div class="filter-actions mt-2">
          <app-export-button
            (export)="exportChange.emit()"
          ></app-export-button>
        </div>
      }

      @if (show) {
        <div class="filter-actions mt-2">
          <p-button
            [label]="'Show all data' | translate"
            (click)="showAllData()"
            severity="secondary"
            label="Secondary"
            styleClass="w-full"
            [disabled]="true">
          </p-button>
        </div>
      }
    </div>
  }
</div>
